
// 练习任务 train api
import { http, https } from '../../global/axios';

//  任务统计列表
export const pracLogs = (params) => {
  return http.post(`v2/tags/practice/task/statistics.json`, params);
};

//  练习题人工审核列表接口
export const practiceLib = (params) => {
  return http.post(`v2/tags/practicelib/list.json`, params);
};

// 培训列表接口
export const  trainList = (params) => {
  return http.post(`v2/tags/train/list.json`, params);
};

// 培训详情
export const trainDetail = (params) => {
  return http.post(`v2/tags/train/steps.json`, params);
};

// 培训当前步骤
export const trainCurrentStep = (params) => {
  return http.post(`v2/tags/train/records.json`, params);
};

// 下一步
export const trainSubmit = (params) => {
  return http.post(`v2/tags/train/commit.json`, params);
};

// 获取练习题结果
export const trainPractice = (params) => {
  return https.post(`v2/tags/train/practicelog.json`, params);
};

export const trainMedal = () => {
  return http.post(`v2/tags/train/medal.json`);
};

// 培训列表接口（无分页）
export const  trainAllList = (params) => {
  return http.post(`v2/tags/train/list_no_page.json`, params);
};

